import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { Placeholder, Tooltip, Whisper } from "rsuite";
import jssVariables from "../../../jss_setup";
import { StyleTypeContext } from "../../../umbilical_tools";

const styles = createUseStyles({
  TripAdvisorWidget: (props) => ({
    padding: `calc(${jssVariables.normal_gap} / 2)`,
    display: "grid",
    justifyItems: "center",
    overflowX: "hidden",
    gridGap: jssVariables.half_gap,
    textAlign: "center",
    ..._.get(props, "customStyles.TripAdvisorWidget", {}),
  }),
  stars: {
    display: "grid",
    gridTemplateColumns: "repeat(6, max-content)",
    gridGap: `calc(${jssVariables.normal_gap} / 2)`,
  },
  star: {
    height: "1rem",
    width: "1rem",
    border: `2px solid ${jssVariables.colors.tripadvisor}`,
    borderRadius: "50%",
    position: "relative",
  },
  fullStar: {
    background: jssVariables.colors.tripadvisor,
    width: "100%",
    height: "100%",
    borderRadius: "50%",
  },
  halfStar: {
    height: ".8rem",
    width: "50%",
    background: jssVariables.colors.tripadvisor,
    borderRadius: "50% 0 0 50%",
  },
  reviews: {
    fontSize: "smaller",
  },
  logo: {
    height: "20px",
    objectFit: "contain",
  },
  viewMoreBtn: (props) => ({
    background: "none",
    borderBottom: `2px solid ${jssVariables.colors.base_color}`,
    padding: 0,
    color: jssVariables.colors.base_color,
    fontWeight: "bold",
    ..._.get(props, "customStyles.viewMoreBtn", {}),
  }),
  placeholder: {
    "width": "100%",
    "& p": {
      marginTop: `calc(${jssVariables.normal_gap} / 2)!important`,
    },
  },
});
export const TripAdvisorWidget = ({
  loading,
  withDetails,
  data,
  onViewDetails,
}) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const classes = styles({
    isMobile: false,
    customStyles: cStyler({
      type,
      brand,
      objName: "TripAdvisorWidget",
    }),
  });

  const rating = Math.floor(parseFloat(_.get(data, "rating", 0)));
  var hasHalf = rating < parseFloat(_.get(data, "rating", 0));

  return _.isEmpty(data) && !loading ? null : (
    <div className={classes.TripAdvisorWidget}>
      {loading ? (
        <Placeholder.Paragraph
          className={classes.placeholder}
          rows={3}
          active={true}
        />
      ) : (
        <React.Fragment>
          <Whisper
            trigger="hover"
            placement="top"
            speaker={<Tooltip>{data.name}</Tooltip>}>
            <div className={classes.stars}>
              <img
                className={classes.logo}
                alt="tripadvisor logo"
                src="https://sisistaticassets.s3.ap-southeast-1.amazonaws.com/tripadvisor/Tripadvisor_Logo_RGB.svg"
              />
              {new Array(rating).fill(1).map((r, idx) => (
                <div key={idx} className={classes.star}>
                  <div className={classes.fullStar} />
                </div>
              ))}
              {hasHalf && (
                <div className={classes.star}>
                  <div className={classes.halfStar} />
                </div>
              )}
              {new Array(5 - (rating + (hasHalf ? 1 : 0)))
                .fill(1)
                .map((r, idx) => (
                  <div key={idx} className={classes.star} />
                ))}
            </div>
          </Whisper>
          <span className={classes.reviews}>
            Based on {data.num_reviews} reviews
          </span>
          <span className={classes.reviews}>
            {_.get(data, "ranking_data.ranking_string")}
          </span>
          {withDetails && (
            <button className={classes.viewMoreBtn} onClick={onViewDetails}>
              View More
            </button>
          )}
        </React.Fragment>
      )}
    </div>
  );
};
TripAdvisorWidget.defaultProps = {
  loading: false,
  withDetails: false,
  data: {},
};
TripAdvisorWidget.propTypes = {
  loading: PropTypes.bool,
  withDetails: PropTypes.bool,
  data: PropTypes.object,
  onViewDetails: PropTypes.func,
};

const tripAdvisorAwardsStyles = createUseStyles({
  TripAdvisorAwards: {
    "position": "absolute",
    "height": "5rem",
    "top": 0,
    "left": 0,
    "display": "grid",
    "gridAutoFlow": "column",
    "& img": {
      height: "7rem",
    },
  },
});
export function TripAdvisorAwards({ data }) {
  const classes = tripAdvisorAwardsStyles();
  return _.get(data, "awards", []).length === 0 ? null : (
    <Whisper
      trigger="hover"
      placement="top"
      speaker={
        <Tooltip>{_.get(data, "awards.0.display_name", "N/A")}</Tooltip>
      }>
      <div className={classes.TripAdvisorAwards}>
        {_.get(data, "awards", [])
          .filter((aw, idx) => idx < 1)
          .map((aw, idx) => (
            <img
              key={idx}
              src={_.get(aw, "images.large")}
              alt={aw.display_name}
            />
          ))}
      </div>
    </Whisper>
  );
}
TripAdvisorAwards.defaultProps = {
  data: {},
};
TripAdvisorAwards.propTypes = {
  data: PropTypes.object,
};
